// extracted by mini-css-extract-plugin
module.exports = {"screenreaderonly":"_35T8Xs","clearfix":"_2JCrlP","icon":"_286Eyb","rating-0":"_2ZI8pQ","rating-6":"EOvyp-","rating-12":"XNOX2e","rating-16":"_19Cb_H","rating-18":"_1ziVAE"};